import { supabase } from '../lib/supabase';

export const profileService = {
  async getProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();

    if (error) throw error;
    return data;
  },

  async updateProfile(userId, updates) {
    const { data, error } = await supabase?.from('user_profiles')?.update({
        full_name: updates?.fullName,
        phone_number: updates?.phoneNumber,
        license_number: updates?.licenseNumber,
        specialization: updates?.specialization,
        institution_name: updates?.institutionName,
        institution_country: updates?.institutionCountry,
        avatar_url: updates?.avatarUrl,
        preferred_modalities: updates?.preferredModalities,
        notification_preferences: updates?.notificationPreferences,
      })?.eq('id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async getAllProfiles() {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async getPendingVerifications() {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('verification_status', 'pending')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async verifyUser(userId, verified) {
    const { data, error } = await supabase?.from('user_profiles')?.update({
        verification_status: verified ? 'verified' : 'rejected',
        verified_at: verified ? new Date()?.toISOString() : null,
        role: verified ? 'clinician' : 'pending',
      })?.eq('id', userId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  async updateUserLanguage(userId, language) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update({ preferred_language: language })?.eq('id', userId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating user language:', error);
      throw error;
    }
  },

  async getUserLanguage(userId) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.select('preferred_language')?.eq('id', userId)?.single();

      if (error) throw error;
      return data?.preferred_language || 'en';
    } catch (error) {
      console.error('Error fetching user language:', error);
      return 'en'; // Default to English on error
    }
  },
};
function updateUserLanguage(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: updateUserLanguage is not implemented yet.', args);
  return null;
}

export { updateUserLanguage };